<template>
  <div>
    <ul v-for="(item) in treeData">
      <hz-tree :data="item">
        <!--<button @click="slot">修改</button>-->
        <span @click="slot"><slot/></span>
      </hz-tree>
    </ul>
  </div>
</template>
<script>

  export default{
    props:{
      treeData:Array,
    },
    methods:{
      slot(){
        // console.log(event.target.parentNode.parentNode);
        let data = JSON.parse(event.target.parentNode.parentNode.getAttribute("data-obj"));
        // console.log(data);
        this.$emit('nodeObject',data);
      },
    }
  }
</script>
<style>
  ul {
    padding-left: 1em;
    line-height: 1.5em;
    list-style-type: dot;
  }
</style>



// WEBPACK FOOTER //
// src/components/test7.vue